module.exports = __webpack_public_path__ + "img/billing.422acfff.png";